<template>
	<section id="activities">
		<!-- Offcanvas for Activities -->
		<div
			class="offcanvas offcanvas-end"
			tabindex="-1"
			id="offcanvasActivities"
			aria-labelledby="offcanvasRightLabel"
		>
			<div class="offcanvas-header d-flex justify-content-between align-items-center">
				<h5 class="p-0 m-0" id="offcanvasRightLabel">👨‍💻 History of changes</h5>
				<button
					type="button"
					class="btn-close text-reset"
					data-bs-dismiss="offcanvas"
					aria-label="Close"
				></button>
			</div>
			<div class="offcanvas-body">
				<!-- List of activities -->
				<div v-if="!loading && activities.length > 0" class="accordion" id="accordionActivities">
					<div v-for="(activity, index) in activities" :key="activity.id" class="accordion-item">
						<h2 class="accordion-header" :id="'headingOne' + activity.id">
							<button
								class="accordion-button p-2"
								type="button"
								data-bs-toggle="collapse"
								:data-bs-target="'#collapseOne' + activity.id"
								aria-expanded="true"
								aria-controls="collapseOne"
							>
								<span
									class="me-1 fw-bold"
									:class="{
										'text-primary': activity.action === 'UPDATED',
										'text-success': activity.action === 'CREATED',
									}"
									>{{ activity.action }}</span
								>
								{{ activity.date }}
							</button>
						</h2>
						<div
							:id="'collapseOne' + activity.id"
							class="accordion-collapse collapse"
							:class="{ show: index === 0 }"
							:aria-labelledby="'headingOne' + activity.id"
							data-bs-parent="#accordionActivities"
						>
							<div class="accordion-body">
								<ul>
									<li>Action: {{ activity.action }}</li>
									<li>Date: {{ activity.created_at }}</li>
									<li v-if="activity.user">User: {{ activity.user.name }}</li>
									<li>IP: {{ activity.ip_address }}</li>
									<li>
										<span class="text-success fw-bold">New value:</span>
										<div v-html="printNewValue(activity)"></div>
									</li>
									<li>
										<span class="text-primary fw-bold">Old value:</span>
										<div v-html="printOldValue(activity)"></div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<div v-else class="p-3">
					<code>There is no activities for this object</code>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { mapState } from 'vuex'
import restApi from '../api/index'
import { handleErrors } from '../actions/helpers'
export default {
	name: 'Activities',
	props: ['subjectType', 'subjectId'],
	data() {
		return {
			loading: false,
			activities: [],
		}
	},
	created() {
		this.getActivities()
	},
	computed: {
		...mapState(['storageUrl']),
	},
	methods: {
		getActivities() {
			this.loading = true
			restApi
				.post(`/activities/subject`, { subjectType: this.subjectType, subjectId: this.subjectId })
				.then(({ data }) => {
					data.forEach(a => {
						a.new_value = JSON.parse(a.new_value)
						delete a.new_value.updated_at
						a.old_value = JSON.parse(a.old_value)
					})
					this.activities = data
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Print new value
		printNewValue(activity) {
			if (activity.new_value !== null) {
				let newValue = '<ul>'
				Object.keys(activity.new_value).forEach(key => {
					newValue += `<li class="text-info fw-bold">${key} : ${activity.new_value[key]}</li>`
				})
				newValue += '</ul>'
				return newValue
			} else {
				return ''
			}
		},

		// Print old value
		printOldValue(activity) {
			if (activity.old_value !== null) {
				let oldValue = '<ul>'
				Object.keys(activity.old_value).forEach(key => {
					if (activity.new_value[key] !== undefined) {
						oldValue += `<li class="text-info fw-bold">${key} : ${activity.old_value[key]}</li>`
					} else {
						oldValue += `<li>${key} : ${activity.old_value[key]}</li>`
					}
				})
				oldValue += '</ul>'
				return oldValue
			} else {
				return "<ul><li>Object don't have old value</li></ul>"
			}
		},
	},
	watch: {},
}
</script>

<style lang="scss" scope>
.accordion-button {
	background-color: white;
}
.accordion-item {
	background-color: white;
	border: 1px solid #f8fafc;
}
</style>
